
import { useAuth } from "@/components/AuthProvider";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ProfileForm } from "./components/ProfileForm";
import { GeneralSettings } from "./components/GeneralSettings";
import { NotificationSettings } from "./components/NotificationSettings";
import { SecuritySettings } from "./components/SecuritySettings";
import { AppearanceSettings } from "./components/AppearanceSettings";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useTranslations } from "@/hooks/useTranslations";

export const Settings = () => {
  const { profile } = useAuth();
  const { t } = useTranslations("settings");
  
  if (!profile) return null;
  
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium">{t("title")}</h3>
        <p className="text-sm text-muted-foreground">
          {t("subtitle")}
        </p>
      </div>

      <Tabs defaultValue="profile" className="space-y-4">
        <ScrollArea className="w-full pb-3">
          <TabsList className="bg-transparent border-b rounded-none h-auto p-0 space-x-6 w-max min-w-full">
            <TabsTrigger value="profile" className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent px-0 pb-3">
              {t("tabs.profile")}
            </TabsTrigger>
            <TabsTrigger value="general" className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent px-0 pb-3">
              {t("tabs.general")}
            </TabsTrigger>
            <TabsTrigger value="notifications" className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent px-0 pb-3">
              {t("tabs.notifications")}
            </TabsTrigger>
            <TabsTrigger value="security" className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent px-0 pb-3">
              {t("tabs.security")}
            </TabsTrigger>
            <TabsTrigger value="appearance" className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent px-0 pb-3">
              {t("tabs.appearance")}
            </TabsTrigger>
          </TabsList>
        </ScrollArea>

        <TabsContent value="profile" className="space-y-4">
          <Card className="rounded-xl overflow-hidden">
            <CardHeader className="bg-gray-50 dark:bg-gray-900 rounded-t-xl">
              <CardTitle>{t("profile.title")}</CardTitle>
              <CardDescription>
                {t("profile.description")}
              </CardDescription>
            </CardHeader>
            <CardContent className="bg-gray-50 dark:bg-gray-900 rounded-b-xl">
              <ProfileForm />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="general">
          <GeneralSettings />
        </TabsContent>

        <TabsContent value="notifications">
          <NotificationSettings />
        </TabsContent>

        <TabsContent value="security">
          <SecuritySettings />
        </TabsContent>

        <TabsContent value="appearance">
          <AppearanceSettings />
        </TabsContent>
      </Tabs>
    </div>
  );
};
